import {Observable} from 'rxjs';
import {marineHubAPI} from '../provider/marineHubAPI';
import {RestQueryParams} from '../base/queryParams';

export function userAPI(id: string): Observable<any> {
    return marineHubAPI.get(`api/users/${id}`, new RestQueryParams());
}
